export default "__VITE_ASSET__CtGTavp8__"